import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import Checkbox from '../../../../components/Checkbox';
import { MdVisibility, MdClose } from 'react-icons/md';
import { Button } from '@/components/Button';

interface Props {
  customFields: { label: string; type: string }[];
  visibleFields: string[];
  setVisibleFields: (fields: string[]) => void;
}

export default function CompaniesVisibleDialog({
  customFields,
  visibleFields,
  setVisibleFields,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const [tempVisibleFields, setTempVisibleFields] = useState<string[]>(visibleFields);

  useEffect(() => {
    if (isOpen) {
      setTempVisibleFields(visibleFields);
    }
  }, [isOpen, visibleFields]);

  return (
    <>
      <Button color="secondary" size="md" onClick={() => setIsOpen(true)}>
        <MdVisibility className="size-icon-xs" />
        項目
      </Button>
      <Dialog
        open={isOpen}
        onOpenChange={(nextOpen) => {
          if (!nextOpen) setIsOpen(false);
        }}
      >
        <DialogContent className="flex max-h-[85vh] w-[90vw] max-w-[860px] flex-col rounded-md">
          <DialogTitle className="flex items-center justify-between border-b border-solid border-border px-lg py-md text-lg! font-bold!">
            表示項目の設定
            <div className="flex gap-2">
              <Button color="tertiary" size="md" onClick={() => setTempVisibleFields([])}>
                <MdClose className="size-icon-xs" />
                すべての選択を解除
              </Button>
            </div>
          </DialogTitle>
          <div className="flex-auto overflow-y-auto p-lg">
            <div className="grid grid-cols-5 gap-sm">
              <>
                {customFields.map((c, key) => (
                  <Checkbox
                    key={key}
                    value={c.type}
                    checked={tempVisibleFields.includes(c.type)}
                    onChange={(checked) => {
                      if (checked) {
                        setTempVisibleFields([...tempVisibleFields, c.type]);
                      } else {
                        setTempVisibleFields(tempVisibleFields.filter((field) => field !== c.type));
                      }
                    }}
                  >
                    <span className="text-sm font-normal">{c.label}</span>
                  </Checkbox>
                ))}
              </>
            </div>
          </div>
          <div className="flex justify-end gap-4 border-t border-solid border-border px-lg py-md">
            <Button
              color="secondary"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              キャンセル
            </Button>
            <Button
              onClick={() => {
                setVisibleFields(tempVisibleFields);
                setIsOpen(false);
              }}
            >
              適用
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
